var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundedLine1Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_232412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 22.4974H7.8326V18.8278C7.8326 16.8016 6.1892 15.1582 4.163 15.1582C2.1368 15.1582 0.5 16.8082 0.5 18.8344",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 22.498H0.5V26.1676C0.5 28.1938 2.1434 29.8372 4.1696 29.8372C6.1958 29.8372 7.8392 28.1938 7.8392 26.1676",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 44.5013H7.8326V40.8317C7.8326 38.8055 6.1892 37.1621 4.163 37.1621C2.1368 37.1621 0.5 38.8055 0.5 40.8317",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 44.502H0.5V51.8346H7.8326V44.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 59.1666V51.834H0.5C0.5 55.8798 3.7802 59.1666 7.8326 59.1666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1634 37.1693V29.8301H11.4938C9.46762 29.8301 7.82422 31.4735 7.82422 33.4997C7.82422 35.5259 9.46762 37.1693 11.4938 37.1693",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83203 51.8347V59.1673H11.5016C13.5278 59.1673 15.1712 57.5239 15.1712 55.4977C15.1712 53.4715 13.5278 51.8281 11.5016 51.8281",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1628 15.1654H22.4954V11.4958C22.4954 9.46957 20.8521 7.82617 18.8259 7.82617C16.7997 7.82617 15.1562 9.46957 15.1562 11.4958",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 15.166H15.1641V18.8356C15.1641 20.8618 16.8075 22.5052 18.8337 22.5052C20.8599 22.5052 22.5033 20.8618 22.5033 18.8356",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1641 29.8301V37.1627H22.4967C22.4967 33.1169 19.2165 29.8301 15.1641 29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 37.1699H15.1641V40.8395C15.1641 42.8657 16.8075 44.5091 18.8337 44.5091C20.8599 44.5091 22.5033 42.8657 22.5033 40.8395",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1696 7.8392C28.1963 7.8392 29.8392 6.19626 29.8392 4.1696C29.8392 2.14294 28.1963 0.5 26.1696 0.5C24.1429 0.5 22.5 2.14294 22.5 4.1696C22.5 6.19626 24.1429 7.8392 26.1696 7.8392Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8314 29.8306V22.498H26.1618C24.1356 22.498 22.4922 24.1414 22.4922 26.1676C22.4922 28.1938 24.1356 29.8372 26.1618 29.8372",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8314 59.1666V51.834H26.1618C24.1356 51.834 22.4922 53.4774 22.4922 55.5036C22.4922 57.5298 24.1356 59.1732 26.1618 59.1732",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8281 15.1646H37.1607V7.83203C33.1149 7.83203 29.8281 11.1188 29.8281 15.1646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 15.166H29.8281V22.4986H37.1607V15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 22.498H29.8281V29.8306H37.1607V22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8281 51.834V59.1666H37.1607C37.1673 55.1142 33.8805 51.834 29.8281 51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1673 66.5006V59.168H29.8281C29.8281 63.2204 33.1149 66.5006 37.1673 66.5006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1719 7.8326H44.5045V0.5C40.4521 0.5 37.1719 3.7802 37.1719 7.8326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 7.83203H37.1719V15.1646C41.2177 15.1646 44.5045 11.8844 44.5045 7.83203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1719 22.4988V29.8314H40.8415C42.8677 29.8314 44.5111 28.188 44.5111 26.1618C44.5111 24.1356 42.8677 22.4922 40.8415 22.4922",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1707 44.5013H44.5033V40.8317C44.5033 38.8055 42.8599 37.1621 40.8337 37.1621C38.8075 37.1621 37.1641 38.8055 37.1641 40.8317",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 51.8346V44.502H37.1719C37.1719 48.5478 40.4521 51.8346 44.5045 51.8346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 59.168H37.1719V66.5006H44.5045V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 0.5H44.5V7.8326H51.8326V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8353 22.4986V15.166H48.1657C46.1395 15.166 44.4961 16.8094 44.4961 18.8356C44.4961 20.8618 46.1395 22.5052 48.1657 22.5052",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1657 37.1693C50.1924 37.1693 51.8353 35.5263 51.8353 33.4997C51.8353 31.473 50.1924 29.8301 48.1657 29.8301C46.139 29.8301 44.4961 31.473 44.4961 33.4997C44.4961 35.5263 46.139 37.1693 48.1657 37.1693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 44.5027V51.8353H48.1696C50.1958 51.8353 51.8392 50.1919 51.8392 48.1657C51.8392 46.1395 50.1958 44.4961 48.1696 44.4961",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 59.168H44.5V66.5006H51.8326V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8359 0.5V7.8326H55.5055C57.5317 7.8326 59.1751 6.1892 59.1751 4.163C59.1751 2.1368 57.5251 0.5 55.4989 0.5",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8359 15.1648V22.4974H55.5055C57.5317 22.4974 59.1751 20.854 59.1751 18.8278C59.1751 16.8016 57.5317 15.1582 55.5055 15.1582",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1673 44.5025V37.1699H55.4977C53.4715 37.1699 51.8281 38.8133 51.8281 40.8395C51.8281 42.8657 53.4715 44.5091 55.4977 44.5091",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8347 59.1673H59.1673V55.4977C59.1673 53.4715 57.5239 51.8281 55.4977 51.8281C53.4715 51.8281 51.8281 53.4715 51.8281 55.4977",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5006 29.8301H59.168V37.1627H66.5006V29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5006 37.1699H59.168V44.5025C63.2204 44.5025 66.5006 41.2157 66.5006 37.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1668 29.8314H66.4994V26.1618C66.4994 24.1356 64.856 22.4922 62.8298 22.4922C60.8036 22.4922 59.1602 24.1356 59.1602 26.1618",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 59.168H51.8359V66.5006C55.8817 66.5006 59.1685 63.2204 59.1685 59.168Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_232412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedLine1Icon);
export default __webpack_public_path__ + "static/media/rounded-line-1-icon.899592f477a71f4d02b4874702e03520.svg";
export { ForwardRef as ReactComponent };